import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"white-space":"pre-line"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  style: {"text-align":"center","margin-top":"16px"}
}

import { computed, ref, watch } from 'vue'
import { NoteType } from '@/types/Note'
import { useNotes } from '@/methods/notesComposables'
import { ElMessage } from 'element-plus'

const INITIAL_COUNT = 5


export default /*@__PURE__*/_defineComponent({
  __name: 'ComReleaseNotesDialog',
  props: {
    "modelValue": { type: Boolean, ...{ required: true } },
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const visible = _useModel<boolean>(__props, "modelValue")

const { notes, error } = useNotes()
const showAll = ref(false)

watch(visible, (val) => {
    if (!val) {
        showAll.value = false
    }
})

watch(error, (value) => {
    if (value) {
        ElMessage.error('Julkaisutietojen haku epäonnistui')
    }
})

const allDates = computed(() => {
    if (!notes.value) return []
    return [...new Set(notes.value.map(note => note.date).reverse())]
})

const visibleDates = computed(() => {
    if (showAll.value) return allDates.value
    return allDates.value.slice(0, INITIAL_COUNT)
})

const hasMore = computed(() => {
    return !showAll.value && allDates.value.length > INITIAL_COUNT
})

const notesByDate = (date: string) => {
    return notes.value?.filter(note => note.date === date) ?? []
}

const noteTypeInfo = (value: string) => {
    const noteType = NoteType[value as keyof typeof NoteType]

    switch (noteType) {
        case NoteType.ench:
            return { name: 'OMINAISUUS', color: 'success' as const }
        case NoteType.fix:
            return { name: 'KORJAUS', color: 'danger' as const }
        case NoteType.perf:
            return { name: 'SUORITUSKYKY', color: 'warning' as const }
        case NoteType.info:
            return { name: 'TIEDOTE', color: 'info' as const }
        default:
            return { name: 'TUNTEMATON', color: 'info' as const }
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "Uutta Vahdissa",
    width: "600px"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDates.value, (date) => {
        return (_openBlock(), _createElementBlock("div", { key: date }, [
          _createElementVNode("h2", null, _toDisplayString(date), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notesByDate(date), (note) => {
            return (_openBlock(), _createElementBlock("div", {
              key: note.id,
              class: "card-margin-bottom"
            }, [
              _createElementVNode("h3", null, _toDisplayString(note.title), 1),
              _createVNode(_component_el_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    type: noteTypeInfo(note.type).color,
                    effect: "dark"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(noteTypeInfo(note.type).name), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"]),
                  (note.tags.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(note.tags, (tag) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: tag,
                          type: "info",
                          effect: "light"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("p", _hoisted_1, _toDisplayString(note.description), 1),
              (note.link)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      href: note.link,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Lue lisää", -1)
                      ]))]),
                      _: 1
                    }, 8, ["href"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      }), 128)),
      (hasMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAll.value = true))
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Näytä lisää", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})